<script>
    import app_alert from "./stores/alerts";

    const yesHandler = () => {
        if ($app_alert.yes_callback) {
            $app_alert.yes_callback();
        }
        app_alert.hide();
    }

    const noHandler = () => {
        if ($app_alert.no_callback) {
            $app_alert.no_callback();
        }
        app_alert.hide();
    }
</script>

<div class="confirm-overlay" class:visible={ $app_alert.visible }>
    <div class="confirm-panel">
        <div class="confirm-heading-{ $app_alert.type }"></div>
        <div class="confirm-body">
            <p class="mrg-t-none">
                {@html $app_alert.prompt}
            </p>
            <div style="margin: 30px auto auto; width: max-content;">
                {#if $app_alert.type === 'confirm' }
                    <button class="btn btn-primary btn-yesno" style="margin-right: 20px;" on:click="{ yesHandler }">
                        Ναι
                    </button>
                    <button class="btn btn-default btn-yesno" on:click="{ noHandler }">Όχι</button>
                {:else if $app_alert.type === 'error' }
                    <button class="btn btn-primary btn-ok" on:click="{ yesHandler }">ΟΚ</button>
                {:else}
                    <button class="btn btn-primary btn-ok" on:click="{ yesHandler }">ΟΚ</button>
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .confirm-overlay.visible {
        display: block;
    }

    .confirm-overlay {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9000;
    }

    .confirm-panel {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: max-content;
        min-width: 250px;
        max-width: 80%;
        background: #fff;
        /*border: 1px solid #ccc;*/
        border-radius: 4px;
    }

    .confirm-panel .confirm-heading-confirm {
        border-top: 10px solid var(--warning-bg-color);
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    .confirm-panel .confirm-heading-alert {
        border-top: 10px solid var(--primary-bg-color);
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    .confirm-panel .confirm-heading-error {
        border-top: 10px solid var(--danger-bg-color);
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }

    .confirm-panel .confirm-body {
        padding: 30px;
    }

    .confirm-panel .btn-ok {
        padding-left: 40px;
        padding-right: 40px;
    }

    .confirm-panel .btn-yesno {
        padding-left: 30px;
        padding-right: 30px;
    }

    @media (max-width: 575px) {
        .confirm-panel {
            width: 80%;
        }
    }
</style>
